export default function ProgressTrail({ month }) {
  return (
    <div
      data-testid="progress-trail"
      className="flex items-center gap-1 md:gap-1.5 flex-wrap"
    >
      {Array.from({ length: 12 }).map((_, i) => {
        const m = i + 1;
        const state = m < month ? "done" : m === month ? "current" : "todo";
        return (
          <div
            key={m}
            className={`trail-dot ${state}`}
            title={`Month ${m}`}
            data-testid={`trail-dot-${m}`}
          />
        );
      })}
    </div>
  );
}
